/**
 * @module login 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApis from '@/Components/Controllers/NormalApis';


export default {
    /**
     * Login
     */
    login(data) {
        const url = `${Env.loginUrl}/api/v1/users/login`;
        return NormalApis.postApi(url, {
          'api-token': Env.loginApiToken
        }, data)
            .then(res => res)
            .catch(err => err);
    },

    /**
     * Login via token
     */
    loginWithToken(data) {
      const url = `${Env.loginUrl}/api/v1/users/tokenLogin`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

     /**
     * Login via social
     */
    loginWithSocial(data) {
      const url = `${Env.loginUrl}/api/v1/users/login_with_social`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

  
    /**
     * Add addAnonymous user
     */
    addAnonymous(data) {
      const url = `${Env.loginUrl}/api/v1/users/add_anonymous`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Verify login user  
     */
    verify(data) {
      const url = `${Env.loginUrl}/api/v1/users/verify_login?platform=web&version=1.0.0`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Verify user email
     */
     verifyEmail(data) {
      const url = `${Env.loginUrl}/api/v1/userVerification/verify`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      },data)
      .then(res => res)
      .catch(err => err);
    },


     /**
     * Login Via Email or phone
     */
    loginViaEmailOrPhone(data) {
      const url = `${Env.loginUrl}/api/v1/users/login/email`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Login Via Email or phone
     */
     verifyPhoneOrEmailLoginToken({ auth_code_token, auth_code }) {
      const url = `${Env.loginUrl}/api/v1/users/login/verify`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      },{
        auth_code_token,
        auth_code
      })
      .then(res => res)
      .catch(err => err);
    },


    
}